import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnDestroy {

  // errorCause: Descripción del error
  errorCause: string;
  // errorStatus: Estado Respuesta del API
  errorStatus: string;

  // title: Título de la página
  title = "Página no encontrada";
  // text: Descripción de la página
  text = "Verifique la información e inténtelo de nuevo";

  constructor() {
    // ↓ Modifica el mensaje de error que se mostrará
    switch (localStorage.getItem("error")) {
      case "Http failure response for  HttpErrorResponse":
        this.errorCause = "En estos momentos el contenido que buscas no está disponible, inténtelo más tarde.";
        break;
      case "Http failure during parsing for  HttpErrorResponse":
        this.errorCause = "El contenido que buscas ya no está disponible.";
        break;
      default: this.errorCause = "El contenido ha sido removido."; break;
    }
    M.toast({ html: "Ha ocurrido un error, verifica la información he inténtelo de nuevo", classes: "background-danger white-text", displayLength: 60000 });
    // ↓ Asigna la información obtenido del storage
    this.errorStatus = localStorage.getItem("status");
  }

  ngOnDestroy() {
    // ↓↓ Elimina la información de errores del storage
    window.localStorage.removeItem("error");
    window.localStorage.removeItem("status");
  }

}
